import { render, staticRenderFns } from "./confirmar_exito.vue?vue&type=template&id=6ddc1154&scoped=true"
import script from "./confirmar_exito.vue?vue&type=script&lang=js"
export * from "./confirmar_exito.vue?vue&type=script&lang=js"
import style0 from "./confirmar_exito.vue?vue&type=style&index=0&id=6ddc1154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddc1154",
  null
  
)

export default component.exports